import { Animation } from '@crabs-ai/web-icons';
import {
  ANIMATION_META,
  AnimationType,
} from '../../items/animation/animation-item-type';

interface TimelineItemAnimationIndicatorProps {
  animationTypes: AnimationType[];
}

export function TimelineItemAnimationIndicator({
  animationTypes,
}: TimelineItemAnimationIndicatorProps) {
  const firstType = animationTypes[0];
  if (!firstType) {
    return null;
  }

  // 두 개 이상의 애니메이션이 적용된 경우 "Mixed" 표시
  const label =
    animationTypes.length > 1 ? 'Mixed' : ANIMATION_META[firstType].name;

  return (
    <div className="pointer-events-none absolute bottom-[0px] left-[0px] flex h-[24px] items-center gap-4xs rounded-3xs bg-sys-style-overlay-inverse-dark px-2xs py-4xs opacity-50">
      <Animation className="size-[12px] [&_path]:fill-sys-style-inverse-light" />
      <span className="text-caption-xsmall overflow-ellipsis whitespace-nowrap text-sys-style-inverse-light">
        {label}
      </span>
    </div>
  );
}
